import React from "react";
import { DropZone } from "../ui/Image_drop";
import StTextArea from "./../ui/stTextArea"
import "tachyons/css/tachyons.css";

export default class MetaTable extends React.Component {
  constructor(props) {
    super();
    this.state = { images: [], mapImage: "" };
    const url = this._parse_query_string();

    const setMetadata = props.setMetadata

    if (props.metadata.copyright === undefined) {
      if (url.copyright !== undefined) {
        let meta = props.metadata;
        meta["copyright"] = url.copyright;
        setMetadata(meta)
      }
    }
    if (props.metadata.imageBaseUrl === undefined) {
      if (url.imageBaseUrl !== undefined) {
        let meta = props.metadata;
        meta["imageBaseUrl"] = url.imageBaseUrl;
        setMetadata(meta)
      }
    }
    if (props.metadata.audioBaseUrl === undefined) {
      if (url.audioBaseUrl !== undefined) {
        let meta = props.metadata;
        meta["audioBaseUrl"] = url.audioBaseUrl;
        setMetadata(meta)
      }
    }

    if (props.metadata.images !== undefined) {
      this.state.images = props.metadata.images.split(",");
    }
    if (props.metadata.mapImageOverlayUrl !== undefined) {
      this.state.mapImage = props.metadata.mapImageOverlayUrl;
    }
    this.handleChange = this.handleChange.bind(this);
  }

  _parse_query_string() {
    const query = window.location.search.substring(1);
    var vars = query.split("&");
    var query_string = {};
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      var key = decodeURIComponent(pair[0]);
      var value = decodeURIComponent(pair[1]);
      // If first entry with this name
      if (typeof query_string[key] === "undefined") {
        query_string[key] = decodeURIComponent(value);
        // If second entry with this name
      } else if (typeof query_string[key] === "string") {
        var arr = [query_string[key], decodeURIComponent(value)];
        query_string[key] = arr;
        // If third or later entry with this name
      } else {
        query_string[key].push(decodeURIComponent(value));
      }
    }
    return query_string;
  }

  handleChange(event) {
    console.log(this.props)
    const { metadata, setMetadata } = this.props;
    let meta = metadata;
    meta[event.target.name] = event.target.value
    setMetadata(meta)
  }

  imageUpdate = images => {
    this.handleChange({ target: { name: "images", value: images.join() } });
  }

  mapImageUpdate = image => {
    let mapImage = Array.from(image);
    console.log(mapImage);
    console.log(map);
    let map = "";
    while (map === "" && mapImage !== []) {
      map = mapImage.pop();
      console.log(map);
    }
    console.log(image);
    console.log(map);
    if (map === undefined) {
      this.handleChange({ target: { name: "mapImageOverlayUrl", value: "" } });
    } else {
      this.handleChange({ target: { name: "mapImageOverlayUrl", value: map } });
    }

    
  }

  AdvancedTab = props => {
    const { metadata, handleChange } = props;
    return ([
      <tr><td><h2 style={{ marginTop: "30px" }}>Advanced Options</h2></td></tr>,
      <tr><td>Copyright:</td><td><input className="prettyInput input" type="text" name="copyright" defaultValue={metadata.copyright} onChange={handleChange} /></td></tr>,
      <tr><td>Image Base Url:</td><td><input className="prettyInput input" type="text" name="imageBaseUrl" defaultValue={metadata.imageBaseUrl} onChange={handleChange} /></td></tr>,
      <tr><td>Audio Base Url:</td><td><input className="prettyInput input" type="text" name="audioBaseUrl" defaultValue={metadata.audioBaseUrl} onChange={handleChange} /></td></tr>
    ]);
  }

  render() {
    const { handleChange, imageUpdate, mapImageUpdate, AdvancedTab } = this
    const { metadata } = this.props;
    const { images, mapImage } = this.state;
    if (metadata !== undefined) {
      return (
        <div>
          <table>
            <tbody>
              <tr><td>Name:</td><td><input className="prettyInput input" type="text" name="title" defaultValue={metadata.title} onChange={handleChange} /></td></tr>
              <tr><td>Description:</td><td><StTextArea style={{ width: "400px", height: "200px" }} html={metadata.desc} callback={(html) => { handleChange({ target: { name: "desc", value: html } }) }} /></td></tr>
              {/* <tr><td>Description:</td><td><textarea style={{ width: "400px", height: "200px" }} className="input" type="text" name="desc" defaultValue={metadata.desc} onChange={handleChange} /></td></tr> */}
              <tr><td>Images:</td><td><DropZone imageBaseUrl={metadata.imageBaseUrl} updateImages={imageUpdate} images={images} aspectRatio={3 / 2} /></td></tr>
              <tr><td>Map Image Overlay:</td><td><DropZone imageBaseUrl={metadata.imageBaseUrl} updateImages={mapImageUpdate} maxPhotos={1} images={[mapImage]} maxLength={4000} /></td></tr>
              <AdvancedTab metadata={metadata} handleChange={handleChange} />
              {/* <tr><td>Map Image Overlay Url:</td><td><input className="input" type="text" name="mapImageOverlayUrl" defaultValue={metadata.mapImageOverlayUrl} onChange={handleChange} /></td></tr> */}
            </tbody>
          </table>
        </div>
      );
    }
    return <div />
  }
}
